import { Spinner } from "@/shared/ui/spinner";

export function PageLoader() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Carregando"
      className="min-h-screen w-full flex items-center justify-center bg-[hsl(var(--bg-page-wellness))] text-primary"
    >
      <Spinner size="lg" />
    </div>
  );
}
